const path = require('path');

module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en'],
  },
  localePath: path.resolve('./public/static/locales'),
  // i18next otherwise prints an advert for Locize every time an instance is
  // built: the server log on each render, the browser console on each load,
  // and once per worker across the test run. Set on the base config so both
  // the render-time instance (lib/i18nConfig) and the one
  // serverSideTranslations builds inherit it. It is JSON-serializable, so it
  // is safe in the page props serverSideTranslations returns.
  showSupportNotice: false,
  reloadOnPrerender: process.env.NODE_ENV === 'development',
};
